const sortPlaylists = function blacklistAndSortPlaylists(ytData, videos) {
  const mergedData = ytData.map(ytItem => {
    const vidData = videos.filter(vid => vid.id === ytItem.id)[0];
    return { ...vidData, ...ytItem };
  });
  return mergedData.sort((a, b) => {
    if (a.episodeNumber > b.episodeNumber) return -1;
    if (a.episodeNumber < b.episodeNumber) return 1;
    return 0;
  });
};

export default sortPlaylists;



// WEBPACK FOOTER //
// ./src/components/getEpisodes/sortVideos.js